import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const MockupZod = z.object({
  __component: z.literal('block.mockup'),
  id: z.number(),
  title: TitleZod,
  media: MediaZod,
  waveWrapper: WaveWrapperZod.nullable(),
});

export { MockupZod };
export type MockupType = z.infer<typeof MockupZod>;
